<template>
  <div class="floating-input-label">
    <select
      ref="field"
      :id="id"
      :name="name"
      :required="required"
      :class="['floating-input-label__select', { filled: !!value, 'user-error': showErrors && invalid, disabled }]"
      :disabled="disabled"
      @change="triggerChange"
    >
      <option value="" :selected="!value"></option>
      <option
        v-for="option in options" :key="option.value"
        :selected="option.value === value"
        :value="option.value"
        v-text="option.label"
      ></option>
    </select>
    <label
      class="floating-input-label__label"
      :for="id"
      v-text="label"
    ></label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    value: String,
    required: Boolean,
    showErrors: Boolean,
    invalid: Boolean,
    disabled: Boolean,
    options: Array,
  },
  computed: {
    id() {
      // eslint-disable-next-line no-underscore-dangle
      return `${this._uid}-${this.name}`;
    },
  },
  methods: {
    triggerChange(event) {
      // set the validity state initially
      this.$emit('change', {
        name: this.name,
        value: event.target.value,
        invalid: !event.target.validity.valid,
      });
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.$refs.field.value) {
        this.$nextTick(() => {
          // after the text input field was updated programmatically trigger change event to revalidate
          this.$refs.field.dispatchEvent(new Event('change'));
        });
      }
    },
  },
  mounted() {
    // set the validity state initially
    this.$emit('change', {
      name: this.name,
      value: this.$refs.field.value,
      invalid: !this.$refs.field.validity.valid,
    });
  },
  name: 'AwardCheckoutFormDropdown',
};
</script>
